import { render, staticRenderFns } from "./ListaAtitude.vue?vue&type=template&id=01d9eea9"
import script from "./ListaAtitude.vue?vue&type=script&lang=js"
export * from "./ListaAtitude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports